import axios from "axios";
import { formatDistanceToNow } from "date-fns";

export const TAXMANDI_URL = process.env.REACT_APP_TAXMANDI_API_URL;
export const PANEL_URL = `${TAXMANDI_URL}/api/panel`;
const TOKEN_KEY = "tm_token";

export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const setToken = (t) => (t ? localStorage.setItem(TOKEN_KEY, t) : localStorage.removeItem(TOKEN_KEY));

export const api = axios.create({ baseURL: `${TAXMANDI_URL}/api` });

api.interceptors.request.use((cfg) => {
  const t = getToken();
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err.response?.status === 401 && getToken() && !err.config.url.includes("/auth/")) {
      setToken(null);
      window.dispatchEvent(new Event("tm-logout"));
    }
    return Promise.reject(err);
  }
);

export const mediaUrl = (u) => (!u ? null : u.startsWith("/api") ? `${TAXMANDI_URL}${u}` : u);

export async function uploadFile(file, onProgress) {
  const fd = new FormData();
  fd.append("file", file);
  const { data } = await api.post("/upload", fd, {
    onUploadProgress: onProgress ? (ev) => onProgress(Math.round((ev.loaded / (ev.total || 1)) * 100)) : undefined,
  });
  return mediaUrl(data.url);
}

export function formatApiError(e) {
  const detail = e?.response?.data?.detail;
  if (detail == null) return e?.message || "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((d) => (d && typeof d.msg === "string" ? d.msg : JSON.stringify(d))).join(" ");
  if (typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export const ago = (iso) => (iso ? formatDistanceToNow(new Date(iso), { addSuffix: true }) : "");

export const inr = (n) => `₹${Number(n).toLocaleString("en-IN")}`;
